import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { EpcotConfigService, EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';

export class RewardTokenLimitation {
    name: string;
    value: string;
}

@Component({
    selector: 'bs-reward-token-limitations',
    templateUrl: './reward-token-limitations.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./reward-token-limitations.component.scss'],
    standalone: false,
})
export class RewardTokenLimitationsComponent {
    @Input() limitations: RewardTokenLimitation[];
    @Input() isRewardDrawerEnabled: boolean;

    isEpcotEnabled = this.epcotConfigService.isEnabled(EpcotModule.Rewards);
    @HostBinding('class') className = 'reward-token-card__limitations';
    @HostBinding('class.reward-drawer__limitations') get rewardDrawerEnabled(): boolean {
        return this.isRewardDrawerEnabled;
    }

    constructor(private epcotConfigService: EpcotConfigService) {}
}
